import script from "./Alarms.vue?vue&type=script&setup=true&lang=js"
export * from "./Alarms.vue?vue&type=script&setup=true&lang=js"

import "./Alarms.vue?vue&type=style&index=0&id=c8d1f67c&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8d1f67c"]])

export default __exports__